export default __webpack_public_path__ + "static/media/back2.d340c21d.jpg";